import React, { Fragment } from "react";
import { Tooltip, IconButton } from "@mui/material";

import NotInterestedIcon from "@mui/icons-material/NotInterested";
import VisibilityIcon from "@mui/icons-material/Visibility";

const ViewFormButton = ({ ...props }) => {
  const { formId, packageId, userId, handleFormClick, isComplete } = props;

  return (
    <Fragment>
      {isComplete && (
        <Tooltip
          title="View"
          onClick={(e) => handleFormClick(e, formId, packageId, userId)}
        >
          <IconButton aria-label="view" size="large">
            <VisibilityIcon />
          </IconButton>
        </Tooltip>
      )}
      {!isComplete && (
        <Tooltip title="Not Complete">
          <IconButton aria-label="not complete" size="large">
            <NotInterestedIcon />
          </IconButton>
        </Tooltip>
      )}
    </Fragment>
  );
};

export default ViewFormButton;
